import { render, staticRenderFns } from "./AddImg.vue?vue&type=template&id=0f06b311&scoped=true"
import script from "./AddImg.vue?vue&type=script&lang=js"
export * from "./AddImg.vue?vue&type=script&lang=js"
import style0 from "./AddImg.vue?vue&type=style&index=0&id=0f06b311&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f06b311",
  null
  
)

export default component.exports